/* eslint-disable @web-monorepo/no-css-file-imports */
import "extended-proptypes/lib/extend-from-standalone";
import "src/stylesheets/normalize.css";
import "src/stylesheets/transitions.css";
import "src/stylesheets/base.css";

import ConundrumsList from "src/pods/conundrums/components/List";

export default function ConundrumsListPage() {
  return <ConundrumsList />;
}
